import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getCodeSystemAndVotesDict = async (foi, apiToken) => {
    console.log("getCodeSystemAndVotesDict")
    let codeSystemAndVotesDict = await getFhirResourceAndMetadata(foi, "CodeSystem", apiToken);
    return codeSystemAndVotesDict;
}

const getFhirResourceAndMetadata = async (foi = null, resourceType = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getfhirresource")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getfhirresource",
            "resourceid": foi,
            "apiToken": apiToken,
            "resourcetype": resourceType
        },
    }).then((resp) => {
        if (resp?.data?.success || resp?.data?.found) {
            return resp.data;
            //resp.data is an object with fhirjsonstring, title, resourcetype, status, found, 
            // loggedin, readpermission, editpermission, adminpermission, 
            // commentsdict, votesdict, myvotesdict
        }
        console.log("NO RESPONSE from getfhirresource call");
    }).catch((error) => { console.log(error); });
};

export default getFhirResourceAndMetadata;
export { getCodeSystemAndVotesDict };